import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mocuts/online_back.png";

function Discover() {
  return (
    <div
      className="discover_section p-100 text_mocuts"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto my-md-0">
            <h1>MoCuts Pro is an online marketplace</h1>
            <p>
              For booking registered barbers, beauticians, and other day-to-day
              barber services.
            </p>
            <p>
              TekRevol partnered up with the client to build an online B2C
              one-stop shop empowering people to book their favorite barbers and
              beauticians from the comfort of their homes.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Discover;
